import axios from "axios";

let razorpayScriptPromise = null;

export const loadRazorpay = () => {
  if (window.Razorpay) {
    return Promise.resolve(window.Razorpay);
  }
  if (razorpayScriptPromise) {
    return razorpayScriptPromise;
  }
  razorpayScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => resolve(window.Razorpay);
    script.onerror = () => {
      razorpayScriptPromise = null;
      reject(new Error("Failed to load Razorpay checkout script"));
    };
    document.body.appendChild(script);
  });
  return razorpayScriptPromise;
};

export const getActivePlans = async () => {
  const userId = localStorage.getItem("user_id");

  const res = await axios.get(`${process.env.REACT_APP_API_URL}razorpay/active-plans`, {
    headers: {
      "accept": "application/json",
      "user-id": userId,
    },
  });

  return res.data;
};
export const getActivePlansid = async () => {
  const userId = localStorage.getItem("user_id");

  try {
    const res = await axios.get(
      process.env.REACT_APP_API_URL + "razorpay/active-plans",
      {
        headers: {
          accept: "application/json",
          "user-id": userId,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error("❌ Error fetching active plans:", error);
    throw error;
  }
};


export const createOrder = async (amount, planId, subscriptionMonths, redemptionRequestId = null) => {
  const userId = localStorage.getItem("user_id");

  const body = {
    amount,
    subscription_months: subscriptionMonths,
  };

  if (redemptionRequestId) {
    body.redemption_request_id = redemptionRequestId;
  }

  const res = await fetch(
    process.env.REACT_APP_API_URL + "razorpay/create-order",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "user-id": userId,
        "plan-id": planId,
      },
      body: JSON.stringify(body),
    }
  );
  return await res.json();
};

export const verifyPayment = async ({
  payment_id,
  order_id,
  signature,
  subscription_months,
}) => {
  const userId = localStorage.getItem("user_id");
  const res = await fetch(process.env.REACT_APP_API_URL + "razorpay/verify-payment", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "subscription_months": subscription_months, // pass as header
    },
    body: JSON.stringify({
      userId,
      payment_id,
      order_id,
      signature,
    }),
  });
  return await res.json();
};

export const getAllInvoices = async () => {
  const userId = localStorage.getItem("user_id");

  const res = await fetch(process.env.REACT_APP_API_URL + "razorpay/invoices", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "user-id": userId,
    },
  });

  return await res.json();
};

export const getSingleInvoice = async (razorpayInvoiceId) => {
  const userId = localStorage.getItem("user_id");

  const res = await fetch(
    `${process.env.REACT_APP_API_URL}razorpay/invoice/${razorpayInvoiceId}`,
    {
      method: "GET", // Use GET to match your backend
      headers: {
        "accept": "application/json",
        "user-id": userId,
      },
    }
  );

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Failed to fetch invoice");
  }

  return await res.json();
};

export const getCurrentPlan = async () => {
  const userId = localStorage.getItem("user_id");

  const res = await fetch(
    `${process.env.REACT_APP_API_URL}razorpay/subscription/current-plan/${userId}`,
    {
      method: "GET",
      headers: {
        "accept": "application/json",
        "user-id": userId,
      },
    }
  );

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || "Failed to fetch current plan");
  }

  return await res.json();
};

export const redeemPoints = async (payload) => {
  const userId = localStorage.getItem("user_id");
  const token = localStorage.getItem("access_token");

  const res = await fetch(process.env.REACT_APP_API_URL + "referrals/redeem", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "accept": "application/json",
      "user-id": userId,
      "Authorization": token ? `Bearer ${token}` : "",
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json();
    throw err;
  }
  return await res.json();
};
